import { Reveal } from "./Reveal";

export const SectionHeading = ({ chapter, label, title, dark = true, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-baseline gap-4 mb-5">
      <span className="font-mono-tech text-xs tracking-[0.25em] text-amber-brand uppercase">
        {chapter}
      </span>
      <span className={`h-px flex-none w-10 ${dark ? "bg-line" : "bg-paper-line"}`} aria-hidden="true" />
      <span className={`font-mono-tech text-xs tracking-[0.25em] uppercase ${dark ? "text-steel" : "text-paper-ink/60"}`}>
        {label}
      </span>
    </div>
    <h2 className={`font-display font-black tracking-tight text-3xl md:text-4xl leading-[1.05] ${dark ? "text-steel-light" : "text-paper-ink"}`}>
      {title}
    </h2>
  </Reveal>
);

export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-line py-6 select-none" aria-hidden="true">
    <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-12">
          <span className="font-display font-black text-2xl md:text-4xl tracking-tight text-transparent" style={{ WebkitTextStroke: "1px #3a3e42" }}>
            {item}
          </span>
          <span className="w-2 h-2 bg-amber-brand rotate-45 flex-none" />
        </span>
      ))}
    </div>
  </div>
);
